import React, { createContext, useState, useContext } from 'react';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [userId, setUserId] = useState(null);
    const [isAdmin, setUserAdminStatus] = useState(false);
    const [isSuperAdmin, setUserSuperAdminStatus] = useState(false);
    const [userName, setUserName] = useState(null);


    return (
        <UserContext.Provider value={{ user, setUser, userId, setUserId, isAdmin, setUserAdminStatus, userName, setUserName, isSuperAdmin, setUserSuperAdminStatus }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);